import { Controller } from "@hotwired/stimulus"

const PREBAKED = {
  thanks:      "Thanks for your feedback! We've noted this and will look into it.",
  in_progress: "Thanks for reporting this — we're actively working on a fix.",
  fixed:       "This has been fixed! Thanks for letting us know.",
  planned:     "Great idea! We've added this to our roadmap.",
  credited:    "Thank you for this valuable feedback! We've awarded you bonus credits."
}

export default class extends Controller {
  static targets = ["response", "aiBtn", "aiLabel", "aiInput"]
  static values  = { suggestUrl: String }

  fill(event) {
    const key = event.currentTarget.dataset.message
    const message = PREBAKED[key] ?? ""

    if (this.#shouldOverwrite()) {
      this.responseTarget.value = message
    }

    this.#highlightButton(event.currentTarget)
  }

  async suggest(event) {
    event.preventDefault()

    const instructions = this.aiInputTarget.value.trim()
    if (!instructions) {
      this.aiInputTarget.focus()
      this.aiInputTarget.classList.add("ring-2", "ring-warning-edge")
      setTimeout(() => this.aiInputTarget.classList.remove("ring-2", "ring-warning-edge"), 1500)
      return
    }

    const btn = this.aiBtnTarget
    btn.disabled = true
    this.aiLabelTarget.textContent = "Thinking…"
    btn.classList.add("opacity-60", "cursor-wait")

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.suggestUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
          "Accept": "application/json"
        },
        body: JSON.stringify({ instructions })
      })

      if (!response.ok) {
        const body = await response.json().catch(() => ({}))
        throw new Error(body.error || `Server returned ${response.status}`)
      }

      const { suggestion } = await response.json()
      this.responseTarget.value = suggestion
      this.responseTarget.focus()
      this.aiLabelTarget.textContent = "Draft"
    } catch (err) {
      console.error("[AI Suggest]", err)
      this.aiLabelTarget.textContent = "Failed"
      setTimeout(() => { this.aiLabelTarget.textContent = "Draft" }, 3000)
    } finally {
      btn.disabled = false
      btn.classList.remove("opacity-60", "cursor-wait")
    }
  }

  #shouldOverwrite() {
    const current = this.responseTarget.value.trim()
    if (current === "") return true
    return Object.values(PREBAKED).some(m => current === m)
  }

  #highlightButton(activeBtn) {
    this.element.querySelectorAll("[data-message]").forEach(btn => {
      btn.classList.remove("ring-2", "ring-brand-edge")
    })
    activeBtn.classList.add("ring-2", "ring-brand-edge")
  }
}
